/* NT redesign – collection carousels + engraving modal (ported from Talia, adapted for Nekuda) */
(function () {
  function initCarousels() {
    document.querySelectorAll('[data-nt-cc]').forEach(function (sec) {
      if (sec.__ntcc) return; sec.__ntcc = 1;
      var track = sec.querySelector('[data-cc-track]');
      if (!track) return;
      sec.querySelectorAll('[data-cc-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.firstElementChild;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
          var step = card ? (card.getBoundingClientRect().width + gap) * 2 : 400;
          // RTL: "next" moves toward the left (negative scrollLeft in Chromium/Firefox/Safari)
          var dir = btn.getAttribute('data-cc-dir') === 'next' ? -1 : 1;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        var x = Math.abs(track.scrollLeft);
        var prev = sec.querySelector('[data-cc-dir="prev"]'), next = sec.querySelector('[data-cc-dir="next"]');
        if (prev) prev.disabled = x < 4;
        if (next) next.disabled = x > max - 4;
        sec.classList.toggle('nt-cc--static', max < 4);
      }
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function initEngrave() {
    var root = document.querySelector('[data-nt-engrave]');
    if (!root || root.__nte) return; root.__nte = 1;
    var WA = '972542546760';
    var modal = root.querySelector('#nt-engrave-modal');
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    var q = function (s) { return modal.querySelector(s); };
    var qty = q('[data-engrave-qty]'), txt = q('[data-engrave-text]'), total = q('[data-engrave-total]'),
        note = q('[data-engrave-tier-note]'), msg = q('[data-engrave-msg]'), wa = q('[data-engrave-wa]'), add = q('[data-engrave-add]');
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) {}
    function tierFor(n) {
      n = Number(n) || 0;
      for (var i = 0; i < tiers.length; i++) if (n >= tiers[i][0] && n <= tiers[i][1]) return tiers[i];
      return null;
    }
    function setMsg(t, err) { if (!msg) return; msg.hidden = !t; msg.textContent = t || ''; msg.toggleAttribute('data-error', !!err); }
    function refresh() {
      var n = parseInt(qty.value, 10) || 0, t = tierFor(n), text = (txt.value || '').trim();
      total.textContent = t ? ('₪' + t[2]) : 'בוואטסאפ';
      note.textContent = t ? ('מדרגה: ' + t[0] + '–' + t[1] + ' יחידות') : (n > 0 ? 'כמות זו מתואמת בוואטסאפ' : 'הזינו כמות');
      var lines = ['שלום, אשמח להזמין הטבעה/הקדשה:', 'כמות: ' + (n || '—') + ' יחידות',
        'עלות לפי מחירון: ' + (t ? '₪' + t[2] : 'לתיאום'), 'טקסט: ' + (text || '(לא צוין)')];
      wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(lines.join('\n'));
      add.disabled = !t;
    }
    function open(e) { if (e) e.preventDefault(); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; setMsg(''); refresh(); setTimeout(function () { qty.focus(); }, 40); }
    function close(e) { if (e) e.preventDefault(); modal.hidden = true; document.documentElement.style.overflow = ''; }
    function addToCart(e) {
      e.preventDefault();
      var n = parseInt(qty.value, 10) || 0, t = tierFor(n), text = (txt.value || '').trim();
      if (!t) { setMsg('כמות זו מתואמת בוואטסאפ', true); return; }
      if (!text) { setMsg('נא להזין טקסט להטבעה לפני ההוספה לעגלה', true); txt.focus(); return; }
      add.disabled = true; setMsg('מוסיף לעגלה…');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: t[3], quantity: 1, properties: { 'כמות יחידות': String(n), 'טקסט להטבעה': text } }] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'שגיאה'); return d; }); })
        .then(function () {
          setMsg('נוסף לעגלה ✓ אפשר להמשיך לקנות או לעבור לקופה');
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('.nt-cart-count').forEach(function (el) { el.textContent = c.item_count; });
          });
        })
        .catch(function (err) { setMsg(err.message || 'לא הצלחנו להוסיף לעגלה', true); })
        .then(function () { add.disabled = false; });
    }
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('[data-engrave-open]')) open(e);
      else if (t.closest('[data-engrave-close]')) close(e);
      else if (t.closest('[data-engrave-add]')) addToCart(e);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    qty.addEventListener('input', refresh); txt.addEventListener('input', refresh);
    refresh();
  }

  function boot() { initCarousels(); initEngrave(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
